import React, { useEffect, useState } from "react";
import { Button, Empty, Spin, Typography } from "antd";
import ProfileHeader from "../../Proflie/ProfileHeader";
import ExploreAgentCard from "../../Card/ExploreAgentCard";
import { TiArrowSortedDown } from "react-icons/ti";
import { fetchAssistantsCreatedByUser } from "../../../api/assistant";

const { Title } = Typography;

const MyAgents = ({
  chatWithAssistant,
  addFavoriteAssistant,
  userId,
  handleCardClick,
  favoriteAssistant,
  setRefresh,
  setFavoriteAssistant,
  HeaderContentChildren,
  enablePersonalize = false,
}) => {
  const [myAgents, setMyAgents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    console.log("Fetching assistants for userId:", userId);

    if (!userId) {
      console.warn("No userId provided, skipping API call.");
      return;
    }

    const fetchAssistants = async () => {
      setLoading(true);
      try {
        const response = await fetchAssistantsCreatedByUser(page, userId, 10);
        console.log("Full API Response:", response);

        if (response?.data) {
          setMyAgents(prev => (page === 1 ? response.data : [...prev, ...response.data]));
          setTotal(response.meta.total);
          console.log("Updated My Agents State:", response.data);
          console.log("Total Assistants:", response.meta.total);
        } else {
          console.warn("No assistants found in API response.");
        }
      } catch (error) {
        console.error("Error fetching assistants:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAssistants();
  }, [userId, page]);

  const handleLoadMore = () => {
    if (myAgents.length < total) {
      setPage(prev => prev + 1);
      console.log("Load More clicked, new page:", page + 1);
    }
  };

  return (
    <Spin spinning={loading}>
      <ProfileHeader
        title="All Agents"
        subHeading="Explore the agents you have created."
      />
      {HeaderContentChildren}

      <div>
        {myAgents.length === 0 && !loading ? (
          <>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            <p className="text-center">No assistants found.</p>
            {console.log("Rendering Empty State: No assistants in myAgents")}
          </>
        ) : (
          <div className="assistant-container">
            {myAgents.map((assistant) => (
              <ExploreAgentCard
                key={assistant._id}
                agent={assistant}
                chatWithAssistant={chatWithAssistant}
                addFavoriteAssistant={addFavoriteAssistant}
                userId={userId}
                handleCardClick={handleCardClick}
                favoriteAssistantData={favoriteAssistant}
                setRefresh={setRefresh}
                setFavoriteAssistant={setFavoriteAssistant}
                enablePersonalize={enablePersonalize}
              />
            ))}
          </div>
        )}
      </div>

      {myAgents.length > 0 && myAgents.length < total && (
        <div className="load-more-container mt-1">
          <div className="load-more-button">
            <Button
              size="small"
              icon={<TiArrowSortedDown />}
              onClick={handleLoadMore}
            >
              Load More
            </Button>
          </div>
          <hr
            style={{
              borderColor: "hsl(0, 0%, 80%)",
              marginTop: "24px",
            }}
          />
        </div>
      )}

      {myAgents.length >= total && myAgents.length > 0 && (
        <span className="text-center w-100 d-block">There is no more data</span>
      )}
    </Spin>
  );
};

export default MyAgents;